// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 394) return "static/chunks/394-634d8ef02ceddd2a.js";
	if (chunkId === 114) return "static/chunks/114-8274bca3e84094a3.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"316":"40809e02dca3b47e","786":"d1cec98ce0fbbf5d","818":"cf0e23a1298138e7"}[chunkId] + ".js";
};